export { default } from './cart-widget-v2.component';
